import type {Timestamp} from 'firebase/firestore';
import type {DateRange} from './date';

export enum ProjectType {
  DEVELOPMENT = 'development',
  CONSULTING = 'consulting'
}

export enum Confidentiality {
  CONFIDENTIAL = 'Confidential',
  NOT_CONFIDENTIAL = 'Not confidential'
}

export enum Visibility {
  PRIVATE = 'Private',
  PUBLIC = 'Public'
}

export enum DiamondSector {
  WEB = 'Web',
  LOCATION = 'Location',
  CLOUD = 'Cloud',
  DATA = 'Data'
}

export enum Topic {
  CLIMATE_CHANGE = 'Climate Change',
  NEW_MOBILITY = 'New Mobility',
  SMART_CITY = 'Smart City',
  SUSTAINABILITY = 'Sustainability',
  TECHNOLOGY = 'Technology'
}

export enum Service {
  ARCHITECTURE = 'Architecture',
  CONCEPT_IDEATION = 'Concept / Ideation',
  CONSOLE_MANAGEMENT = 'Console Management',
  CONSULTING = 'Consulting',
  DATA_ANALYSIS = 'Data Analysis',
  DESIGN_UX = 'Design / UX',
  DEVELOPMENT = 'Development',
  HOSTING = 'Hosting',
  INTEGRATION = 'Integration',
  MIGRATION = 'Migration',
  PROJECT_MANAGEMENT = 'Project Management',
  RESEARCH = 'Research',
  RESELLING_LICENSE = 'Reselling / License',
  TECHNICAL_ENABLEMENT = 'Technical Enablement',
  TECHNICAL_EVALUATION = 'Technical Evaluation'
}

export enum Task {
  DASHBOARDS = 'Dashboards',
  DATA_SHARING = 'Data Sharing',
  FEATURE_DEMO = 'Feature Demo',
  LOCATOR = 'Locator',
  PLANNING = 'Planning',
  PREDICTION = 'Prediction',
  VISUALIZATION = 'Visualization'
}

export enum Field {
  EDUCATION = 'Education',
  ENERGY = 'Energy',
  EVENTS = 'Events',
  FINANCIAL_SERVICES_AND_INSURANCE = 'Financial Services + Insurance',
  HEALTH_CARE = 'Health Care',
  LOGISTICS = 'Logistics',
  MANUFACTURING = 'Manufacturing',
  MEDIA_AND_ENTERTAINMENT = 'Media + Entertainment',
  MOBILITY = 'Mobility',
  NGO = 'NGO',
  PUBLIC_SECTOR = 'Public Sector',
  REAL_ESTATE = 'Real Estate',
  RETAIL = 'Retail',
  TRAVEL = 'Travel'
}

export enum Technology {
  '360_STREETVIEW' = '360° / StreetView',
  '3D' = '3D',
  ACCESSIBILITY = 'Accessibility',
  ANDROID = 'Android',
  ANDROID_ARCHITECTURE_COMPONENTS = 'Android Architecture Components',
  ANDROID_FOREGROUND_SERVICE = 'Android Foreground Service',
  AR_VR = 'AR / VR',
  BACKBONE = 'Backbone',
  BLUETOOTH = 'Bluetooth',
  BROWSER = 'Browser',
  CARDBOARD = 'Cardboard',
  CARTO = 'Carto',
  CESIUM = 'Cesium',
  CLOUD_BUILD = 'Cloud Build',
  CLOUD_FUNCTIONS = 'Cloud Functions',
  CLOUD_LOAD_BALANCES = 'Cloud Load Balancer',
  CLOUD_RUN = 'Cloud Run',
  CLOUD_SQL = 'Cloud SQL',
  CLOUDBASED_MAP_STYLING = 'Cloud-based Map Styling',
  COMPUTE = 'Compute',
  CONTENT_MANAGEMENT_SYSTEM = 'Content Management System',
  COUCHDB = 'CouchDB',
  CSS = 'CSS',
  D3 = 'D3',
  DATA_STUDIO = 'Data Studio',
  DATA_VISUALIZATION = 'Data Visualization',
  DATA_WAREHOUSE = 'Data Warehouse',
  DECKGL = 'deck.gl',
  DFI = 'DFI (dynamische Fahrgastinformation)',
  DISTANCE_MATRIX = 'Distance Matrix',
  EXCEL = 'Excel',
  EXPRESS = 'Express',
  FIREBASE_CLOUD_MESSAGING = 'Firebase Cloud Messaging',
  FIRESTORE = 'Firestore',
  FIRETABLE = 'Firetable',
  FLUTTER = 'Flutter',
  FUSED_LOCATION_PROVIDER = 'Fused Location Provider',
  GEOCODING = 'Geocoding',
  GO = 'Go',
  GOOGLE_CLOSURE_FRAMEWORK = 'Google Closure Framework',
  GOOGLE_CLOUD = 'Google Cloud',
  GOOGLE_CLOUD_FUNCTIONS = 'Google Cloud Functions',
  GOOGLE_CLOUD_PLATFORM = 'Google Cloud Platform',
  GOOGLE_CLOUD_STORAGE = 'Google Cloud Storage',
  GOOGLE_DISPATCH = 'Google Dispatch',
  GOOGLE_EARTH = 'Google Earth',
  GOOGLE_MAPS_API = 'Google Maps API',
  GOOGLE_MAPS_DIRECTIONS_API = 'Google Maps Directions API',
  GOOGLE_MAPS_PLACES_API = 'Google Maps Places API',
  GOOGLE_MAPS_PLATFORM = 'Google Maps Platform',
  GOOGLE_MAPS_STYLES = 'Google Maps Styles',
  GOOGLE_SPREADSHEET = 'Google Spreadsheet',
  GRAPHHOPPER = 'Graphhopper',
  GTFE = 'GTFS',
  HTML = 'HTML',
  INTERNATIONALIZATION = 'Internationalization',
  IOS = 'iOS',
  JAVA = 'Java',
  JAVASCRIPT = 'JavaScript',
  KEPLERGL = 'Kepler.gl',
  KOTLIN = 'Kotlin',
  LEAFLET = 'Leaflet',
  LIGHTROOM = 'Lightroom',
  LITELEMENT = 'LitElement',
  LIVE_TRACKING = 'Live Tracking',
  LOOKER = 'Looker',
  LOOKER_EMBED_SDK = 'Looker Embed SDK',
  MACHINE_LEARNING = 'Machine Learning',
  MAPBOX = 'Mapbox',
  MAPBOXGL = 'Mapbox GL',
  MAPS = 'Maps',
  MATERIAL_UI = 'Material UI',
  MOBILE = 'Mobile',
  NODE_WEBKIT = 'Node Webkit',
  NODEJS = 'Node.js',
  OPEN_STREET_MAP = 'Open Street Map',
  OPENMAPTILES = 'Openmaptiles',
  PLACES = 'Places',
  POSTGRESQL = 'PostgreSQL',
  POWERBI = 'PowerBI',
  PREACT = 'Preact',
  PWA = 'PWA (Progressive Web App)',
  PYTHON = 'Python',
  QGIS = 'QGIS',
  QGIS_SERVER = 'QGIS-Server',
  REACT = 'React',
  REDUX = 'Redux',
  ROUTING = 'Routing',
  RUBY_ON_RAILS = 'Ruby on Rails',
  RXJAVA = 'RxJava',
  SECURITY = 'Security',
  SERVICEWORKER = 'ServiceWorker',
  STREAMING = 'Streaming',
  SVG = 'SVG',
  TARGOMO_API = 'Targomo API',
  TERRAFORM = 'Terraform',
  THREEJS = 'Three.js',
  TURF = 'Turf',
  TYPESCRIPT = 'TypeScript',
  UNFOLDEDAI = 'Unfolded.ai',
  UX_UI_DESIGN = 'UX / UI Design',
  VANILLA_JS = 'Vanilla JS',
  VUEJS = 'Vue.js',
  WEB_COMPONENTS = 'Web Components',
  WEB_WORKER_API = 'Web Worker API',
  WEBGL = 'WebGL',
  WEBSOCKETS = 'WebSockets',
  WEBVR = 'WebVR',
  WORKBOX = 'Workbox',
  WORKSPACE = 'Workspace'
}

export enum Format {
  COACHING = 'Coaching',
  CODE_REVIEW = 'Code review',
  SEMINAR = 'Seminar',
  SPARRING = 'Sparring',
  TRAINING = 'Training',
  WEBINAR = 'Webinar',
  WORKSHOP = 'Workshop'
}

export enum DevelopmentProjectURLTypes {
  REPOSITORY = 'Repository',
  DEPLOYMENT = 'Deployment',
  DOCUMENTATION = 'Documentation',
  BLOG_POST = 'Blog Post',
  SOCIAL_MEDIA = 'Social Media Post',
  OTHER = 'Other'
}
export enum ConsultingProjectURLTypes {
  PRESENTATION = 'Presentation',
  FEEDBACK_FORM = 'Feedback Form'
}

export type URLTypes = DevelopmentProjectURLTypes | ConsultingProjectURLTypes;
export const URLTypes = {
  ...ConsultingProjectURLTypes,
  ...DevelopmentProjectURLTypes
};

export interface ProjectURL {
  type: URLTypes;
  url: string;
}

export interface ImageMedia {
  type: 'image';
  name: string;
  url: string;
  width: number;
  height: number;
  caption?: string;
  focusPoint?: {x: number; y: number};
}

export interface ImageFile extends ImageMedia {
  blob: Blob;
  onDelete: () => void;
}

export interface VideoMedia {
  type: 'video';
  url: string;
}

export type Media = ImageMedia | VideoMedia;

export interface DevelopmentProject {
  id: string;
  createdAt: Timestamp;
  type: ProjectType.DEVELOPMENT;
  isDraft: false;
  confidentiality: Confidentiality;
  visibility: Visibility;
  diamond?: Record<DiamondSector, 0 | 1 | 2 | 3 | 4>;
  title: string;
  title_En?: string;
  description: string;
  description_En?: string;
  projectLead: Array<string>;
  team: Array<string>;
  customers?: Array<string>;
  contactPerson?: {name?: string; url?: string};
  tasks: Array<string>;
  fields: Array<string>;
  technologies: Array<string>;
  topics: Array<string>;
  services: Array<string>;
  creationPeriod: DateRange;
  urls?: Array<ProjectURL>;
  media?: Array<Media>;
  relatedProjects?: Array<string>;
}

export interface DevelopmentProjectDraft
  extends Partial<
      Omit<
        DevelopmentProject,
        'isDraft' | 'id' | 'createdAt' | 'type' | 'title'
      >
    >,
    Required<Pick<DevelopmentProject, 'id' | 'createdAt' | 'type' | 'title'>> {
  isDraft: true;
}

export interface ConsultingProject
  extends Omit<DevelopmentProject, 'type' | 'tasks' | 'technologies'> {
  type: ProjectType.CONSULTING;
  valueInTime?: number; // in hours
  valueInPrice?: number; // in euros
  zohoUrl?: string;
  formats: Array<string>;
  methods: Array<string>;
}

export interface ConsultingProjectDraft
  extends Partial<
      Omit<ConsultingProject, 'isDraft' | 'id' | 'createdAt' | 'type' | 'title'>
    >,
    Required<Pick<ConsultingProject, 'id' | 'createdAt' | 'type' | 'title'>> {
  isDraft: true;
}

type FormData<T> = Omit<T, 'id' | 'createdAt' | 'type' | 'isDraft'>;

export type DevelopmentProjectFormData = FormData<DevelopmentProject>;
export type DevelopmentProjectDraftFormData = FormData<DevelopmentProjectDraft>;

export type ConsultingProjectFormData = FormData<ConsultingProject>;
export type ConsultingProjectDraftFormData = FormData<ConsultingProjectDraft>;

export interface ProjectFormData
  extends DevelopmentProjectFormData,
    ConsultingProjectFormData {}

export interface ProjectDraftFormData
  extends DevelopmentProjectDraftFormData,
    ConsultingProjectDraftFormData {}

export type Project = DevelopmentProject | ConsultingProject;
export type ProjectDraft = DevelopmentProjectDraft | ConsultingProjectDraft;
